/**
 * Replaces the public S3 endpoint with the internal S3 endpoint in the given image URL.
 *
 * @example
 * - `http://localhost:9000/blesk/123.jpg` => `http://img-proxy:8080/blesk/123.jpg`
 *
 * @param imageUrl
 * @param config
 */
export const formatImageToInternalUrl = (
  imageUrl: string | null,
  config: {
    s3PublicEndpoint: string | null;
    s3InternalPublicEndpoint: string | null;
  },
) => {
  if (!imageUrl || !config.s3PublicEndpoint || !config.s3InternalPublicEndpoint) {
    return imageUrl;
  }
  return imageUrl.replace(config.s3PublicEndpoint, config.s3InternalPublicEndpoint);
};
